/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Generating_LeadInputs */

const en_us2_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It takes a few seconds.`)
};

const pt_br2_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leva alguns segundos.`)
};

const es_419_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarda unos segundos.`)
};

const pt_pt2_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demora alguns segundos.`)
};

const fr_fr2_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça prend quelques secondes.`)
};

const de_de2_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das dauert ein paar Sekunden.`)
};

const it_it2_draft_generating_lead = /** @type {(inputs: Draft_Generating_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci vogliono pochi secondi.`)
};

/**
* | output |
* | --- |
* | "It takes a few seconds." |
*
* @param {Draft_Generating_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_generating_lead = /** @type {((inputs?: Draft_Generating_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Generating_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_generating_lead(inputs)
	if (locale === "es-419") return es_419_draft_generating_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_generating_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_generating_lead(inputs)
	if (locale === "de-DE") return de_de2_draft_generating_lead(inputs)
	if (locale === "it-IT") return it_it2_draft_generating_lead(inputs)
	return en_us2_draft_generating_lead(inputs)
});
export { draft_generating_lead as "draft.generating_lead" }